import { Router } from "vue-router";

export const mypageUtils = {
  handleBack(router: Router, prevRoute: any, homeRedirectRoutesAdd?: string[]) {
    let previousRouteName = prevRoute?.name ?? '';
    // If previous route name is undefined -> redirect to the home page.
    const homeRedirectRoutes = ['a10'];
    if (homeRedirectRoutesAdd) {
      homeRedirectRoutes.push(...homeRedirectRoutesAdd);
    }
    if (!previousRouteName || homeRedirectRoutes.includes(previousRouteName)) {
      previousRouteName = 'f00';
    }

    let params = {};
    if (prevRoute?.params) {
      params = prevRoute.params;
    }
    let query = {};
    if (prevRoute?.query) {
      query = prevRoute.query;
    }
    router.replace({
      name: previousRouteName,
      params: params,
      query: query,
    });
  }
};